import { render, staticRenderFns } from "./ContactEditRights.vue?vue&type=template&id=8825489a&"
import script from "./ContactEditRights.vue?vue&type=script&lang=js&"
export * from "./ContactEditRights.vue?vue&type=script&lang=js&"
import style0 from "./ContactEditRights.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports